let topCoverMobileHeight = null;
let topCoverMobileOrientation = null;
let topCoverIsMobile = null;

function getTopCoverHeaderHeight() {
  let headerHeight = 0;
  let header = document.querySelectorAll(".shopify-section-group-header-group");

  header.forEach((element) => {
    headerHeight += element.offsetHeight;
  });

  return headerHeight;
}

function getTopCoverOrientation() {
  return window.innerWidth > window.innerHeight ? "landscape" : "portrait";
}

function isTopCoverMobile() {
  return window.matchMedia("(max-width: 749px)").matches;
}

function fixHeightCover(forceRecalculate = false) {
  let container = document.getElementById("top-cover");
  let minHeight = 500;
  let headerHeight = getTopCoverHeaderHeight();
  let isMobile = isTopCoverMobile();
  let orientation = getTopCoverOrientation();
  let fixHeight;

  document.documentElement.style.setProperty("--top-cover-header-height", headerHeight + "px");

  if (isMobile) {
    if (forceRecalculate || topCoverMobileHeight === null || topCoverMobileOrientation !== orientation) {
      topCoverMobileHeight = Math.max(window.innerHeight - headerHeight, minHeight);
      topCoverMobileOrientation = orientation;
    }

    fixHeight = topCoverMobileHeight;
  } else {
    fixHeight = Math.max(window.innerHeight - headerHeight, minHeight);
    topCoverMobileHeight = null;
    topCoverMobileOrientation = null;
  }

  topCoverIsMobile = isMobile;

  if (container !== null) {
    container.style.height = fixHeight + "px";
  }
}

fixHeightCover(true);

document.addEventListener("DOMContentLoaded", () => {
  fixHeightCover(true);
});

window.addEventListener("resize", () => {
  let isMobile = isTopCoverMobile();

  if (!isMobile || topCoverIsMobile !== isMobile) {
    fixHeightCover(true);
  }
});

window.addEventListener("orientationchange", () => {
  window.setTimeout(() => {
    fixHeightCover(true);
  }, 250);
});
